export default {
    baseUrl: 'http://officialapi.ifreegroup.co//index.php/',
    defaults: {
        l: 'zh-cn'
    }
}



// WEBPACK FOOTER //
// ./src/lib/config.js